import React from "react";

export type ModernMediasfuGenericHeadParameters = Record<string, any> & {
  getCurrentParams?: () => ModernMediasfuGenericHeadParameters;
  renderModernMediasfuUI?: () => React.ReactElement;
};

export type ModernMediasfuGenericHeadOptions = {
  /** Latest parameter bag published by the existing headless room engine. */
  parameters: ModernMediasfuGenericHeadParameters;
};

/**
 * Renders the exact ModernMediasfuGeneric UI from one existing room engine.
 * The engine remains the sole owner of sockets, media and UI state.
 */
const ModernMediasfuGenericHead: React.FC<ModernMediasfuGenericHeadOptions> = ({ parameters }) => {
  const current = parameters.getCurrentParams?.() ?? parameters;
  const renderUI = current.renderModernMediasfuUI;
  if (typeof renderUI !== "function") return null;
  return renderUI();
};

export default ModernMediasfuGenericHead;
